<template>
	<div class="modal fade" id="clienteModal" role="dialog" aria-labelledby="clienteModalLabel" aria-hidden="true">
		<div class="modal-dialog modal-dialog-centered modal-xl" role="document">
			<div class="modal-content">
	  			<div class="modal-header">
	    			<h5 class="modal-title" id="clienteModalLabel">
	    				<i class="material-icons">edit</i>
	    				Editar {{cliente.nombre}}
	    			</h5>
	  			</div>
	  			<preloader v-if="loading || loadingStore"></preloader>
	  			<div class="modal-body p-0">
					<div class="card-group">
					    <div class="card col-md-9 p-0">
					        <div class="card-body pt-0 pb-0">
					            <ul class="nav nav-tabs nav-fill" role="tablist">
					                <li class="nav-item">
					                    <a class="nav-link active" data-toggle="tab" href="#detalleCliente" role="tab">Info. General</a>
					                </li>
					                <li class="nav-item" v-if="cliente.tipo_persona=='I'">
			                        	<a class="nav-link" data-toggle="tab" href="#otrosClientes" role="tab">Otros datos</a>
			                        </li>
			                        <li class="nav-item" v-if="hasPrestamos">
			                        	<a class="nav-link" data-toggle="tab" href="#prestamosClientes" role="tab">Préstamos</a>
			                        </li>
					            </ul>

					            <div class="tab-content" style="margin-top: 20px;">
					                <div class="tab-pane active" id="detalleCliente" role="tabpanel">
					                    <div class="form-row">
					                        <div class="col-md-3 bg-light">
					                            <clientes-avatar id="logo" :route="avatar_url" :cliente="''+codigo+''" :alt="cliente.nombre"></clientes-avatar>
					                            <div class="text-center">
					                                <label for="logo" style="cursor: pointer;">
					                                    Cambiar Avatar
					                                </label>
					                            </div>
					                        </div>
					                        <div class="col-md-9">
					                            <div class="form-row">
					                                <div class="col-md-6 mb-3">
					                                    <label>Vendedor:</label>
					                                    <catalogo-vendedores
					                                        id="vendedorCliente"
					                                        name="vendedorCliente"
					                                        v-model="cliente.vendedor"
					                                        autofocus>
					                                    </catalogo-vendedores>
					                                    <div v-if="errors && errors.vendedor" class="text-danger">
					                                        {{ errors.vendedor[0] }}
					                                    </div>
					                                </div>

					                                <div class="col-md-6 mb-3">
					                                    <label>Tipo Cliente:</label>
					                                    <div class="text-center">
					                                        <div class="custom-control custom-radio custom-control-inline">
					                                            <input type="radio" id="tipoPersonaEmpresa" name="tipoPersona" class="custom-control-input" value="E" v-model="cliente.tipo_persona">
					                                            <label class="custom-control-label" for="tipoPersonaEmpresa">Empresa</label>
					                                        </div>
					                                        <div class="custom-control custom-radio custom-control-inline">
					                                            <input type="radio" id="tipoPersonaIndividual" name="tipoPersona" class="custom-control-input" value="I" v-model="cliente.tipo_persona">
					                                            <label class="custom-control-label" for="tipoPersonaIndividual">Persona Individual</label>
					                                        </div>
					                                    </div>
					                                    <div v-if="errors && errors.tipo_persona" class="text-danger">
					                                        {{ errors.tipo_persona[0] }}
					                                    </div>
					                                </div>  

					                                <div class="col-md-8 mb-3">
					                                    <label for="name">Nombre:</label>
					                                    <input id="name" type="text" class="form-control form-control-sm" name="name" v-model="cliente.nombre" placeholder="Nombre" maxlength="100">
					                                    <div v-if="errors && errors.nombre" class="text-danger">
					                                        {{ errors.nombre[0] }}
					                                    </div>
					                                </div>

					                                <div class="col-md-4 mb-3">
					                                    <label for="segmento">Segmento:</label>
					                                    <catalogo-segmentos id="segmentoCliente" name="segmentoCliente" v-model="cliente.segmento"></catalogo-segmentos>
					                                    <div v-if="errors && errors.segmento" class="text-danger">
					                                        {{ errors.segmento[0] }}
					                                    </div>
					                                </div>
					                            </div>
					                        </div>

					                        <div class="col-md-3 mb-3">
					                            <label for="nit">{{configuracion.CLIENTES_NIT || 'NIT'}}:</label>
					                            <input id="nit" type="text" class="form-control form-control-sm" name="nit" v-model="cliente.nit" :placeholder="configuracion.CLIENTES_NIT" maxlength="25">
					                            <div v-if="errors && errors.nit" class="text-danger">
					                                {{ errors.nit[0] }}
					                            </div>
					                        </div>

					                        <div class="col-md-5 mb-3">
					                            <label for="nombre_facturacion">Nombre de Facturación:</label>
					                            <input id="nombre_facturacion" type="text" class="form-control form-control-sm" name="nombre_facturacion" v-model="cliente.nombre_facturacion" placeholder="Nombre de Facturación" maxlength="150">

					                            <div v-if="errors && errors.nombre_facturacion" class="text-danger">
			                                        {{ errors.nombre_facturacion[0] }}
			                                    </div>
					                        </div>

					                        <div class="col-md-4 mb-3">
					                            <label for="corporacion">Corporación:</label>
					                            <catalogo-corporaciones id="corporacionCliente" name="corporacionCliente" v-model="cliente.corporacion">
					                            </catalogo-corporaciones>
					                            <div v-if="errors && errors.corporacion" class="text-danger">
			                                        {{ errors.corporacion[0] }}
			                                    </div>
					                        </div>

					                        <div class="col-md-6 mb-3">
					                            <label for="representante_legal">Representante Legal:</label>
					                            <input id="representante_legal" type="text" class="form-control form-control-sm" name="representante_legal" v-model="cliente.representante_legal" placeholder="Representante Legal" maxlength="150">
					                            <div v-if="errors && errors.representante_legal" class="text-danger">
			                                        {{ errors.representante_legal[0] }}
			                                    </div>
					                        </div>

					                        <div class="col-md-3 mb-3" v-if="configuracion.CLIENTES_MENSAJERO">
					                            <label for="mensajero">Mensajero:</label>
					                            <catalogo-mensajeros id="mensajeroCliente" name="mensajero" v-model="cliente.mensajero">
					                            </catalogo-mensajeros>

					                            <div v-if="errors && errors.mensajero" class="text-danger">
			                                        {{ errors.mensajero[0] }}
			                                    </div>
					                        </div>

					                        <div class="col-md-3 mb-3" v-if="configuracion.CLIENTES_CANAL_PAGO">
					                            <label>Canal de Pago:</label>
					                            <catalogo-formas-pagos id="forma_pagoCliente" name="forma_pagoCliente" v-model="cliente.forma_pago">
					                            </catalogo-formas-pagos>

					                            <div v-if="errors && errors.forma_pago" class="text-danger">
			                                        {{ errors.forma_pago[0] }}
			                                    </div>
					                        </div>

					                        <div class="col-md-12">
					                            <div class="form-row">
					                                <div class="col-md-12 mb-3">
					                                    <label for="notas">Notas:</label>
					                                    <textarea id="notas" type="text" class="form-control" name="notas" placeholder="Si necesita, escriba aquí sus notas." maxlength="250" v-model="cliente.notas"></textarea>
					                                    <div v-if="errors && errors.notas" class="text-danger">
					                                        {{ errors.notas[0] }}
					                                    </div>
					                                </div>
					                            </div>  
					                        </div>
					                    </div>
					                </div>
					                <div class="tab-pane" id="otrosClientes" role="tabpanel" v-if="cliente.tipo_persona=='I'">
					                	<div class="row" id="personaIndividualContainer">
			                                <div class="col-md-4 mb-3">
			                                    <label for="documento">Identificación:</label>
			                                    <input id="documento" type="text" class="form-control form-control-sm" name="documento" v-model="cliente.docto_identifica" placeholder="Documento de Identificación">
			                                    <div v-if="errors && errors.docto_identifica" class="text-danger">
			                                        {{ errors.docto_identifica[0] }}
			                                    </div>
			                                </div>

			                                <div class="col-md-4 mb-3">
			                                    <label for="puesto">Puesto:</label>
			                                    <input id="puesto" type="text" class="form-control form-control-sm" name="puesto" v-model="cliente.puesto" placeholder="Puesto" maxlength="25">
			                                    <div v-if="errors && errors.puesto" class="text-danger">
			                                        {{ errors.puesto[0] }}
			                                    </div>
			                                </div>

			                                <div class="col-md-4 mb-3">
			                                    <label for="fecha_nacimiento">Fecha de Nacimiento:</label>
			                                    <date-picker 
			                                        id="fecha_nacimiento"
			                                        type="text" 
			                                        class="form-control form-control-sm"
			                                        name="fecha_nacimiento" 
			                                        v-model="cliente.fecha_nacimiento"
			                                        placeholder="Fecha de Nacimiento"></date-picker>
			                                    <div v-if="errors && errors.fecha_nacimiento" class="text-danger">
			                                        {{ errors.fecha_nacimiento[0] }}
			                                    </div>
			                                </div>

			                                <div class="col-md-6 mb-3">
			                                    <label for="profesion">Profesión:</label>
			                                    <input id="profesion" type="text" class="form-control form-control-sm" name="profesion" v-model="cliente.profesion" placeholder="Profesión de Identificación" maxlength="100">
			                                    <div v-if="errors && errors.profesion" class="text-danger">
			                                        {{ errors.profesion[0] }}
			                                    </div>
			                                </div>

			                                <div class="col-md-6 mb-3">
			                                    <label for="estado_civil">Estado Civil:</label>
			                                    <catalogo-estado-civil id="estado_civilCliente" name="estado_civilCliente" v-model="cliente.estado_civil"></catalogo-estado-civil>
			                                    <div v-if="errors && errors.estado_civil" class="text-danger">
			                                    	{{ errors.estado_civil[0] }}
			                                    </div>
			                                </div>

			                                <div class="col-md-4 mb-3">
			                                    <label for="nacionalidad">Nacionalidad:</label>
			                                    <input id="nacionalidad" type="text" class="form-control form-control-sm" name="nacionalidad" v-model="cliente.nacionalidad" placeholder="Nacionalidad" maxlength="100">
			                                    <div v-if="errors && errors.nacionalidad" class="text-danger">
			                                        {{ errors.nacionalidad[0] }}
			                                    </div>
			                                </div>

			                                <div class="col-md-4 mb-3">
			                                    <label for="licencia">Licencia de Conducir:</label>
			                                    <input id="licencia" type="text" class="form-control form-control-sm" name="licencia" v-model="cliente.licencia" placeholder="Licencia de Conducir" maxlength="50">
			                                    <div v-if="errors && errors.licencia" class="text-danger">
			                                        {{ errors.licencia[0] }}
			                                    </div>
			                                </div>

			                                
		                                    <div class="col-md-4 mb-3" v-if="configuracion.CLIENTES_AFILIACION_IGSS">
		                                        <label for="no_afiliacion_igss">Número de afiliación de IGSS:</label>
		                                        <input id="no_afiliacion_igss" type="text" class="form-control form-control-sm" name="no_afiliacion_igss" v-model="cliente.numero_afiliacion_igss" placeholder="Número de afiliación de IGSS" maxlength="50">
		                                        <div v-if="errors && errors.numero_afiliacion_igss" class="text-danger">
			                                        {{ errors.numero_afiliacion_igss[0] }}
			                                    </div>
		                                    </div>
			                            </div>
					                </div>

					                <div class="tab-pane" id="prestamosClientes" role="tabpanel" v-if="hasPrestamos">
			                            <div class="row">
			                            	<div class="col-md-4 mb-3">
			                                    <label for="tiene_dependiente_economico">¿Tiene dependientes económicos?</label>
			                                    <dynamic-factores id="tiene_dependiente_economico" name="tiene_dependiente_economico" 
			                                        v-model="cliente.prestamo.tiene_dependiente_economico" column="CLIENTES_PRESTAMO.TIENE_DEPENDIENTE_ECONOMICO"></dynamic-factores>
			                                    <div v-if="errorPrestamo && errorPrestamo.tiene_dependiente_economico" class="text-danger">
			                                        {{ errorPrestamo.tiene_dependiente_economico[0] }}
			                                    </div>
			                                </div>

			                                <div class="col-md-4 mb-3">
			                                    <label for="dependientes">Número Dependientes:</label>
			                                    <dynamic-factores id="dependientes" name="dependientes" column="CLIENTES_PRESTAMO.NO_DEPENDIENTES" v-model="cliente.prestamo.no_dependientes" placeholder="Número Dependientes"></dynamic-factores>
			                                    <div v-if="errorPrestamo && errorPrestamo.dependientes" class="text-danger">
			                                        {{ errorPrestamo.dependientes[0] }}
			                                    </div>
			                                </div>

			                                <div class="col-md-4 mb-3">
			                                    <label for="cuenta_bancaria">Cuenta Bancaria:</label>
			                                    <dynamic-factores id="cuenta_bancaria" name="cuenta_bancaria" v-model="cliente.prestamo.cuenta_bancaria" placeholder="Cuenta Bancaria" column="CLIENTES_PRESTAMO.CUENTA_BANCARIA"></dynamic-factores>
			                                    <div v-if="errorPrestamo && errorPrestamo.cuenta_bancaria" class="text-danger">
			                                        {{ errorPrestamo.cuenta_bancaria[0] }}
			                                    </div>
			                                </div>

			                                <div class="col-md-4 mb-3">
			                                    <label for="tipo_cuenta">Tipo Cuenta:</label>
			                                    <dynamic-factores id="tipo_cuenta" name="tipo_cuenta" v-model="cliente.prestamo.tipo_cuenta" placeholder="Tipo Cuenta" column="CLIENTES_PRESTAMO.TIPO_CUENTA"></dynamic-factores>
			                                    <div v-if="errorPrestamo && errorPrestamo.tipo_cuenta" class="text-danger">
			                                        {{ errorPrestamo.tipo_cuenta[0] }}
			                                    </div>
			                                </div>

			                                <div class="col-md-4 mb-3">
			                                    <label for="banco">Banco:</label>
			                                    <dynamic-factores id="banco" name="banco" v-model="cliente.prestamo.banco" placeholder="Banco" column="CLIENTES_PRESTAMO.BANCO"></dynamic-factores>
			                                    <div v-if="errorPrestamo && errorPrestamo.banco" class="text-danger">
			                                        {{ errorPrestamo.banco[0] }}
			                                    </div>
			                                </div>

			                                <div class="col-md-4 mb-3">
			                                    <label for="sueldo">Sueldo:</label>
			                                    <dynamic-factores id="sueldo" name="sueldo" v-model="cliente.prestamo.sueldo" placeholder="Sueldo" column="CLIENTES_PRESTAMO.SUELDO"></dynamic-factores>
			                                    <div v-if="errorPrestamo && errorPrestamo.sueldo" class="text-danger">
			                                        {{ errorPrestamo.sueldo[0] }}
			                                    </div>
			                                </div>

			                                <div class="col-md-4 mb-3">
			                                    <label for="fecha_prox_pago">Fecha Próximo Pago:</label>
			                                    <dynamic-factores id="fecha_prox_pago" name="fecha_prox_pago" v-model="cliente.prestamo.fecha_prox_pago" column="CLIENTES_PRESTAMO.FECHA_PROX_PAGO"></dynamic-factores>
			                                    <div v-if="errorPrestamo && errorPrestamo.fecha_prox_pago" class="text-danger">
			                                        {{ errorPrestamo.fecha_prox_pago[0] }}
			                                    </div>
			                                </div>

			                                <div class="col-md-4 mb-3">
			                                    <label for="direccion_trabajo">Dirección Trabajo:</label>
			                                    <dynamic-factores id="direccion_trabajo" name="direccion_trabajo" 
			                                    placeholder="Dirección Trabajo" column="CLIENTES_PRESTAMO.DIRECCION_TRABAJO" v-model="cliente.prestamo.direccion_trabajo"></dynamic-factores>
			                                    <div v-if="errorPrestamo && errorPrestamo.direccion_trabajo" class="text-danger">
			                                        {{ errorPrestamo.direccion_trabajo[0] }}
			                                    </div>
			                                </div>

			                                <div class="col-md-4 mb-3">
			                                    <label for="fecha_ini_trabajo">Fecha Inicial Trabajo:</label>
			                                    <dynamic-factores id="fecha_ini_trabajo" name="fecha_ini_trabajo" v-model="cliente.prestamo.fecha_ini_trabajo" column="CLIENTES_PRESTAMO.FECHA_INI_TRABAJO"></dynamic-factores>
			                                    <div v-if="errorPrestamo && errorPrestamo.fecha_ini_trabajo" class="text-danger">
			                                        {{ errorPrestamo.fecha_ini_trabajo[0] }}
			                                    </div>
			                                </div>

			                                <div class="col-md-4 mb-3">
			                                    <label for="tiempo_trabajado">Tiempo Trabajado (años):</label>
			                                    <dynamic-factores id="tiempo_trabajado" name="tiempo_trabajado" v-model="cliente.prestamo.tiempo_trabajado" column="CLIENTES_PRESTAMO.TIEMPO_TRABAJADO"></dynamic-factores>
			                                    <div v-if="errorPrestamo && errorPrestamo.tiempo_trabajado" class="text-danger">
			                                        {{ errorPrestamo.tiempo_trabajado[0] }}
			                                    </div>
			                                </div>

			                                <div class="col-md-4 mb-3">
			                                    <label for="horario">Horario:</label>
			                                    <dynamic-factores id="horario" name="horario" v-model="cliente.prestamo.horario" placeholder="Horario" column="CLIENTES_PRESTAMO.HORARIO"></dynamic-factores>
			                                    <div v-if="errorPrestamo && errorPrestamo.horario" class="text-danger">
			                                        {{ errorPrestamo.horario[0] }}
			                                    </div>
			                                </div>

			                                <div class="col-md-4 mb-3">
			                                    <label for="nombre_supervisor">Nombre Supervisor:</label>
			                                    <dynamic-factores id="nombre_supervisor" name="nombre_supervisor" v-model="cliente.prestamo.nombre_supervisor" placeholder="Nombre Supervisor" column="CLIENTES_PRESTAMO.NOMBRE_SUPERVISOR"></dynamic-factores>
			                                    <div v-if="errorPrestamo && errorPrestamo.nombre_supervisor" class="text-danger">
			                                        {{ errorPrestamo.nombre_supervisor[0] }}
			                                    </div>
			                                </div>

			                                <div class="col-md-4 mb-3">
			                                    <label for="nombre_rrhh">Nombre RRHH:</label>
			                                    <dynamic-factores id="nombre_rrhh" name="nombre_rrhh" v-model="cliente.prestamo.nombre_rrhh" placeholder="Nombre RRHH" column="CLIENTES_PRESTAMO.NOMBRE_RRHH"></dynamic-factores>
			                                    <div v-if="errorPrestamo && errorPrestamo.nombre_rrhh" class="text-danger">
			                                        {{ errorPrestamo.nombre_rrhh[0] }}
			                                    </div>
			                                </div>

			                                <div class="col-md-4 mb-3">
			                                    <label for="persona_expuesta">Persona expuesta políticamente (PEP):</label>
			                                    <dynamic-factores id="persona_expuesta" name="persona_expuesta" v-model="cliente.prestamo.persona_expuesta" placeholder="Persona Expuesta" column="CLIENTES_PRESTAMO.PERSONA_EXPUESTA"></dynamic-factores>
			                                    <div v-if="errorPrestamo && errorPrestamo.persona_expuesta" class="text-danger">
			                                        {{ errorPrestamo.persona_expuesta[0] }}
			                                    </div>
			                                </div>

			                                <div class="col-md-4 mb-3">
			                                    <label for="nivel">Nivel:</label>
			                                    <dynamic-factores id="nivel" name="nivel" v-model="cliente.prestamo.nivel" column="CLIENTES_PRESTAMO.NIVEL"></dynamic-factores>
			                                    <div v-if="errorPrestamo && errorPrestamo.nivel" class="text-danger">
			                                        {{ errorPrestamo.nivel[0] }}
			                                    </div>
			                                </div>
			                                
			                                <div class="col-md-4 mb-3">
			                                    <label for="cliente_permite_avisos">¿Permite Avisos?</label>
			                                    <dynamic-factores id="cliente_permite_avisos" name="permite_avisos" v-model="cliente.prestamo.permite_avisos" column="CLIENTES_PRESTAMO.PERMITE_AVISOS"></dynamic-factores>
			                                    <div v-if="errorPrestamo && errorPrestamo.permite_avisos" class="text-danger">
			                                        {{ errorPrestamo.permite_avisos[0] }}
			                                    </div>
			                                </div>

			                                <div class="col-md-4 mb-3">
			                                    <label for="ingresos_aproximados">Ingresos Aproximados:</label>
			                                    <dynamic-factores id="ingresos_aproximados" name="ingresos_aproximados" v-model="cliente.prestamo.ingresos_aproximados" placeholder="Ingresos Aproximados" column="CLIENTES_PRESTAMO.INGRESOS_APROXIMADOS"></dynamic-factores>
			                                    <div v-if="errorPrestamo && errorPrestamo.ingresos_aproximados" class="text-danger">
			                                        {{ errorPrestamo.ingresos_aproximados[0] }}
			                                    </div>
			                                </div>

			                                <div class="col-md-4 mb-3">
			                                    <label for="egresos_aproximados">Egresos Aproximados:</label>
			                                    <dynamic-factores id="egresos_aproximados" name="egresos_aproximados" v-model="cliente.prestamo.egresos_aproximados" placeholder="Egresos Aproximados" column="CLIENTES_PRESTAMO.EGRESOS_APROXIMADOS"></dynamic-factores>
			                                    <div v-if="errorPrestamo && errorPrestamo.egresos_aproximados" class="text-danger">
			                                        {{ errorPrestamo.egresos_aproximados[0] }}
			                                    </div>
			                                </div>

			                                <div class="col-md-4 mb-3">
			                                    <label for="ingresos_reales">Ingresos Reales:</label>
			                                    <dynamic-factores id="ingresos_reales" name="ingresos_reales" v-model="cliente.prestamo.ingresos_reales" placeholder="Ingresos Reales" column="CLIENTES_PRESTAMO.INGRESOS_REALES"></dynamic-factores>
			                                    <div v-if="errorPrestamo && errorPrestamo.ingresos_reales" class="text-danger">
			                                        {{ errorPrestamo.ingresos_reales[0] }}
			                                    </div>
			                                </div>

			                                <div class="col-md-4 mb-3">
			                                    <label for="egresos_reales">Egresos reales:</label>
			                                    <dynamic-factores id="egresos_reales" name="egresos_reales" v-model="cliente.prestamo.egresos_reales" placeholder="Egresos reales" column="CLIENTES_PRESTAMO.EGRESOS_REALES"></dynamic-factores>
			                                    <div v-if="errorPrestamo && errorPrestamo.egresos_reales" class="text-danger">
			                                        {{ errorPrestamo.egresos_reales[0] }}
			                                    </div>
			                                </div>

			                                <div class="col-md-4 mb-3">
			                                    <label>Diferencia ingreso - egreso:</label>
			                                    <input type="text" class="form-control form-control-sm" v-bind:value="totalIngEgrReales"  disabled>
			                                </div>

			                                <div class="col-md-4 mb-3">
			                                    <label for="capacidad_endeudamiento">Capacidad de Endeudamiento:</label>
			                                    <dynamic-factores id="capacidad_endeudamiento" name="capacidad_endeudamiento" v-model="cliente.prestamo.capacidad_endeudamiento" placeholder="Capacidad Endeudamiento" column="CLIENTES_PRESTAMO.CAPACIDAD_ENDEUDAMIENTO"></dynamic-factores>
			                                    <div v-if="errorPrestamo && errorPrestamo.capacidad_endeudamiento" class="text-danger">
			                                        {{ errorPrestamo.capacidad_endeudamiento[0] }}
			                                    </div>
			                                </div>

			                                <div class="col-md-4 mb-3">
			                                    <label for="cliente_es_profesional">¿Es profesional?</label>
			                                    <dynamic-factores id="cliente_es_profesional" name="es_profesional" v-model="cliente.prestamo.es_profesional" column="CLIENTES_PRESTAMO.ES_PROFESIONAL"></dynamic-factores>
			                                    <div v-if="errorPrestamo && errorPrestamo.es_profesional" class="text-danger">
			                                        {{ errorPrestamo.es_profesional[0] }}
			                                    </div>
			                                </div>

			                                <div class="col-md-4 mb-3">
			                                    <label for="cliente_esta_orgulloso_actividades">¿Está orgulloso de sus actividades?</label>
			                                    <dynamic-factores id="cliente_esta_orgulloso_actividades" name="esta_orgulloso_actividades" v-model="cliente.prestamo.esta_orgulloso_actividades" column="CLIENTES_PRESTAMO.ESTA_ORGULLOSO_ACTIVIDADES"></dynamic-factores>
			                                    <div v-if="errorPrestamo && errorPrestamo.esta_orgulloso_actividades" class="text-danger">
			                                        {{ errorPrestamo.esta_orgulloso_actividades[0] }}
			                                    </div>
			                                </div>

			                                <div class="col-md-4 mb-3">
			                                    <label for="edad">Edad del solicitante:</label>
			                                    <dynamic-factores id="edad" name="edad" v-model="cliente.prestamo.edad" placeholder="Edad del solicitante" column="CLIENTES_PRESTAMO.EDAD"></dynamic-factores>
			                                    <div v-if="errorPrestamo && errorPrestamo.edad" class="text-danger">
			                                        {{ errorPrestamo.edad[0] }}
			                                    </div>
			                                </div>

			                                <div class="col-md-4 mb-2">
			                                    <label for="ocupacion">Ocupación:</label>
			                                    <dynamic-factores id="ocupacion" type="text" name="ocupacion" v-model="cliente.prestamo.ocupacion" placeholder="Ocupación" column="CLIENTES_PRESTAMO.OCUPACION"></dynamic-factores>
			                                    <div v-if="errorPrestamo && errorPrestamo.ocupacion" class="text-danger">
			                                        {{ errorPrestamo.ocupacion[0] }}
			                                    </div>
			                                </div>

			                                <div class="col-md-4 mb-3">
			                                    <label for="inicio_labores">Inicio de labores:</label>
			                                    <dynamic-factores id="inicio_labores" name="inicio_labores" v-model="cliente.prestamo.inicio_labores" placeholder="Inicio de labores" column="CLIENTES_PRESTAMO.INICIO_LABORES">
			                                    </dynamic-factores>
			                                    <div v-if="errorPrestamo && errorPrestamo.inicio_labores" class="text-danger">
			                                        {{ errorPrestamo.inicio_labores[0] }}
			                                    </div>
			                                </div>

			                                <div class="col-md-4 mb-3">
			                                    <label for="capacidad_endeudamiento_porcentaje">Capacidad de endeudamiento porcentaje:</label>
			                                    <dynamic-factores id="capacidad_endeudamiento_porcentaje" name="capacidad_endeudamiento_porcentaje" v-model="cliente.prestamo.capacidad_endeudamiento_porcentaje" placeholder="Capacidad de endeudamiento porcentaje" column="CLIENTES_PRESTAMO.CAPACIDAD_ENDEUDAMIENTO_PORCENTAJE">
			                                    </dynamic-factores>
			                                    <div v-if="errorPrestamo && errorPrestamo.capacidad_endeudamiento_porcentaje" class="text-danger">
			                                        {{ errorPrestamo.capacidad_endeudamiento_porcentaje[0] }}
			                                    </div>
			                                </div>
			                                
			                                <div class="col-md-4 mb-3">
			                                    <label for="CLIENTES_DEPARTAMENTO">Departamento:</label>
			                                    <dynamic-factores id="CLIENTES_DEPARTAMENTO" name="CLIENTES_DEPARTAMENTO" class="flex-fill" v-model="cliente.prestamo.departamento" column="CLIENTES_PRESTAMO.DEPARTAMENTO"></dynamic-factores>
			                                    <div v-if="errorPrestamo && errorPrestamo.departamento" class="text-danger">
			                                        <small>
			                                            {{ errorPrestamo.departamento[0] }}
			                                        </small>
			                                    </div>
			                                </div>
			                                
			                                <div class="col-md-4 mb-3">
			                                    <label for="CLIENTES_MUNICIPIO">Municipio:</label>
			                                    <dynamic-factores id="CLIENTES_MUNICIPIO" name="CLIENTES_MUNICIPIO" class="flex-fill" v-model="cliente.prestamo.municipio" :filter="cliente.prestamo.departamento" column="CLIENTES_PRESTAMO.MUNICIPIO"></dynamic-factores>
			                                    <div v-if="errorPrestamo && errorPrestamo.municipio" class="text-danger">
			                                        <small>
			                                            {{ errorPrestamo.municipio[0] }}
			                                        </small>
			                                    </div>
			                                </div>

			                                <div class="col-md-4 mb-3">
			                                    <label for="AFILIACION_IGSS">Afiliación IGSS:</label>
			                                    <dynamic-factores id="AFILIACION_IGSS" name="AFILIACION_IGSS" class="flex-fill" v-model="cliente.prestamo.afiliacion_igss" column="CLIENTES_PRESTAMO.AFILIACION_IGSS"></dynamic-factores>
			                                    <div v-if="errorPrestamo && errorPrestamo.municipio" class="text-danger">
			                                        <small>
			                                            {{ errorPrestamo.municipio[0] }}
			                                        </small>
			                                    </div>
			                                </div>
			                            </div>
			                        </div>
					            </div>
					        </div>
					    </div>

					    <div class="card col-md-3 p-0">
			                <div class="card-header">
			                    <h3 class="card-title">
			                        Datos de Contacto
			                    </h3>
			                </div>
			                <div class="card-body">
			                    <div class="form-row">
			                        <div class="col-md-6 mb-2">
			                            <label for="telefono">Teléfono:</label>
			                            <input id="telefono" type="text" class="form-control" name="telefono" v-model="cliente.telefono" placeholder="Teléfono">
			                            <div v-if="errors && errors.telefono" class="text-danger">
	                                        {{ errors.telefono[0] }}
	                                    </div>
			                        </div>

			                        <div class="col-md-6 mb-2">
			                            <label for="celular">Celular:</label>
			                            <input id="celular" type="text" class="form-control" name="celular" v-model="cliente.celular" placeholder="Celular">
			                            <div v-if="errors && errors.celular" class="text-danger">
	                                        {{ errors.celular[0] }}
	                                    </div>
			                        </div>

			                        <div class="col-md-12 mb-2">
			                            <label for="email">
			                                Correo electrónico:
			                            </label>
			                            <input id="email" type="email" class="form-control" name="email" v-model="cliente.email" placeholder="Correo electrónico">
			                            <div v-if="errors && errors.email" class="text-danger">
	                                        {{ errors.email[0] }}
	                                    </div>
			                        </div>

			                        <div class="col-md-12 mb-2">
			                            <label for="usuario_facebook">Página Web:</label>
			                            <input id="usuario_facebook" type="text" class="form-control" name="usuario_facebook" v-model="cliente.usuario_facebook" placeholder="https://www.site.com/" maxlength="50">

			                            <div v-if="errors && errors.usuario_facebook" class="text-danger">
	                                        {{ errors.usuario_facebook[0] }}
	                                    </div>
			                        </div>

			                        <div class="col-md-12 mb-2">
			                            <label for="direccion">Dirección:</label>
			                            <textarea 
			                            id="direccion" 
			                            type="text" 
			                            class="form-control"
			                            name="direccion" 
			                            placeholder="Dirección"
			                            rows="1"
			                            maxlength="250"
			                            v-model="cliente.direccion"></textarea>
			                            <div v-if="errors && errors.direccion" class="text-danger">
	                                        {{ errors.direccion[0] }}
	                                    </div>
			                        </div>

			                        <div class="col-md-12" v-if="configuracionBase.CLIENTES_DIRECCION_COBRO">
			                            <label for="direccion_cobro">Dirección Cobro:</label>
			                            <textarea 
			                                id="direccion_cobro" 
			                                type="text" 
			                                class="form-control" 
			                                name="direccion_cobro" 
			                                placeholder="Dirección Cobro"
			                                rows="1"
			                                maxlength="250"
			                                v-model="cliente.direccion_cobro"></textarea>
			                            <div v-if="errors && errors.direccion_cobro" class="text-danger">
	                                        {{ errors.direccion_cobro[0] }}
	                                    </div>
			                        </div>
			                    </div>
			                </div>
			            </div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-link" v-on:click="closeModal()" :disabled="loadingStore">Cancelar</button>
					<button type="button" class="btn btn-primary" v-on:click="updateCliente()" :disabled="loading || loadingStore">Actualizar cliente</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data(){
			return {
				loading: false,
				loadingStore: false,
				codigo: 0,
				errors: {},
				cliente: {
					nombre:'',
		        	tipo_cliente:'',
		        	docto_identifica:'',
		        	nit:'',
		        	celular:'',
		        	direccion:'',
		        	telefono:'',
		        	email:'',
		        	usuario_facebook:'',
		        	fecha_nacimiento:'',
		        	puesto:'',
		        	notas:'',
		        	vendedor:'',
		        	segmento:'',
		        	corporacion:'',
		        	ultimo_contacto:'',
		        	ultima_venta:'',
		        	nombre_facturacion:'',
		        	forma_pago:'',
		        	mensajero:'',
		        	direccion_cobro:'',
		        	tipo_persona:'',
		        	avatar_url:'',
		        	profesion:'',
		        	estado_civil:'',
		        	nacionalidad:'',
		        	licencia:'',
		        	representante_legal:'',
		        	numero_afiliacion_igss:'',
		        	prestamo: {
		        		no_dependientes: '',
						cuenta_bancaria: '',
						tipo_cuenta: '',
						banco: '',
						sueldo: '',
						fecha_prox_pago: '',
						direccion_trabajo: '',
						fecha_ini_trabajo: '',
						tiempo_trabajado: '',
						HORARIO: '',
						nombre_supervisor: '',
						nombre_rrhh: '',
						persona_expuesta: '',
						nivel: '',
						permite_avisos: '',
						ingresos_aproximados: '',
						ingresos_reales: '',
						egresos_aproximados: '',
						egresos_reales: '',
						capacidad_endeudamiento: '',
						es_profesional: '',
						esta_orgulloso_actividades: '',
						edad: '',
						tiene_dependiente_economico: '',
						ocupacion: '',
						inicio_labores: '',
						capacidad_endeudamiento_porcentaje: '',
						municipio: '',
						departamento: '',
						afiliacion_igss: ''
		        	}
				}
			}
		},

		mounted(){
			var vm = this
			$(this.$el).on('shown.bs.modal', function (event) {
				var button = $(event.relatedTarget)
				var cliente = button.data('cliente')
				vm.errors = {}
				vm.codigo = cliente
				vm.getCliente()
			})
		},

		methods: {
			getCliente: function(){
				this.loading = true
				var url = 'api/clientes/'+this.codigo

				axios.get(url)
				.then(response => {
					this.setCliente(response.data)
				}).catch(error => {
					
				}).then(()=>{
					this.loading = false
				})
			},

			updateCliente: function(){
				this.loadingStore = true
				this.errors = {}
				var url = 'api/clientes/'+this.codigo

				axios.put(url, this.cliente)
				.then(response => {
					this.$toasted.show('cliente ha sido actualizado')
					this.closeModal()
					this.$store.dispatch('setCliente', response.data)
				}).catch(error => {
					if (error.response.status === 422) {
                    	this.errors = error.response.data.errors || {};
                    }
				}).then(()=>{
					this.loadingStore = false
				})
			},

			closeModal(){
				this.errors = {}
				$(this.$el).modal('hide')
			},

			setCliente(data){
				this.cliente.nombre = data.NOMBRE_CLIENTE
	        	this.cliente.tipo_cliente = data.TIPO_CLIENTE
	        	this.cliente.docto_identifica = data.DOCTO_IDENTIFICA
	        	this.cliente.nit = data.NIT
	        	this.cliente.celular = data.CELULAR
	        	this.cliente.direccion = data.DIRECCION
	        	this.cliente.telefono = data.TELEFONO
	        	this.cliente.email = data.EMAIL
	        	this.cliente.usuario_facebook = data.USUARIO_FACEBOOK
	        	this.cliente.fecha_nacimiento = data.FECHA_NACIMIENTO
	        	this.cliente.puesto = data.PUESTO
	        	this.cliente.notas = data.NOTAS
	        	this.cliente.vendedor = data.CODIGO_VENDEDOR
	        	this.cliente.segmento = data.CODIGO_SEGMENTO
	        	this.cliente.corporacion = data.CODIGO_CORPORACION
	        	this.cliente.ultimo_contacto = data.ULTIMO_CONTACTO
	        	this.cliente.ultima_venta = data.ULTIMA_VENTA
	        	this.cliente.nombre_facturacion = data.NOMBRE_FACTURACION
	        	this.cliente.forma_pago = data.CODIGO_FORMA_PAGO
	        	this.cliente.mensajero = data.CODIGO_MENSAJERO
	        	this.cliente.direccion_cobro = data.DIRECCION_COBRO
	        	this.cliente.tipo_persona = data.TIPO_PERSONA || 'I'
	        	this.cliente.avatar_url = data.AVATAR_URL
	        	this.cliente.profesion = data.PROFESION
	        	this.cliente.estado_civil = data.ESTADO_CIVIL
	        	this.cliente.nacionalidad = data.NACIONALIDAD
	        	this.cliente.licencia = data.LICENCIA
	        	this.cliente.representante_legal = data.REPRESENTANTE_LEGAL
	        	this.cliente.numero_afiliacion_igss = data.NUMERO_AFILIA_IGSS

	        	if (data.prestamo) {
		        	this.cliente.prestamo.no_dependientes = data.prestamo.NO_DEPENDIENTES
					this.cliente.prestamo.cuenta_bancaria = data.prestamo.CUENTA_BANCARIA
					this.cliente.prestamo.tipo_cuenta = data.prestamo.TIPO_CUENTA
					this.cliente.prestamo.banco = data.prestamo.BANCO
					this.cliente.prestamo.sueldo = data.prestamo.SUELDO
					this.cliente.prestamo.fecha_prox_pago = data.prestamo.FECHA_PROX_PAGO
					this.cliente.prestamo.direccion_trabajo = data.prestamo.DIRECCION_TRABAJO
					this.cliente.prestamo.fecha_ini_trabajo = data.prestamo.FECHA_INI_TRABAJO
					this.cliente.prestamo.tiempo_trabajado = data.prestamo.TIEMPO_TRABAJADO
					this.cliente.prestamo.horario = data.prestamo.HORARIO
					this.cliente.prestamo.nombre_supervisor = data.prestamo.NOMBRE_SUPERVISOR
					this.cliente.prestamo.nombre_rrhh = data.prestamo.NOMBRE_RRHH
					this.cliente.prestamo.persona_expuesta = data.prestamo.PERSONA_EXPUESTA
					this.cliente.prestamo.nivel = data.prestamo.NIVEL
					this.cliente.prestamo.permite_avisos = data.prestamo.PERMITE_AVISOS 
					this.cliente.prestamo.ingresos_aproximados = data.prestamo.INGRESOS_APROXIMADOS
					this.cliente.prestamo.ingresos_reales = data.prestamo.INGRESOS_REALES
					this.cliente.prestamo.egresos_aproximados = data.prestamo.EGRESOS_APROXIMADOS
					this.cliente.prestamo.egresos_reales = data.prestamo.EGRESOS_REALES
					this.cliente.prestamo.capacidad_endeudamiento = data.prestamo.CAPACIDAD_ENDEUDAMIENTO
					this.cliente.prestamo.es_profesional = data.prestamo.ES_PROFESIONAL 
					this.cliente.prestamo.esta_orgulloso_actividades = data.prestamo.ESTA_ORGULLOSO_ACTIVIDADES
					this.cliente.prestamo.edad = data.prestamo.EDAD
					this.cliente.prestamo.tiene_dependiente_economico = data.prestamo.TIENE_DEPENDIENTE_ECONOMICO
					this.cliente.prestamo.ocupacion = data.prestamo.OCUPACION
					this.cliente.prestamo.inicio_labores = data.prestamo.INICIO_LABORES
					this.cliente.prestamo.capacidad_endeudamiento_porcentaje = data.prestamo.CAPACIDAD_ENDEUDAMIENTO_PORCENTAJE
					this.cliente.prestamo.departamento = data.prestamo.DEPARTAMENTO
					this.cliente.prestamo.municipio = data.prestamo.MUNICIPIO
					this.cliente.prestamo.afiliacion_igss = data.prestamo.AFILIACION_IGSS
				}else{
					this.cliente.prestamo.no_dependientes = ''
					this.cliente.prestamo.cuenta_bancaria = ''
					this.cliente.prestamo.tipo_cuenta = ''
					this.cliente.prestamo.banco = ''
					this.cliente.prestamo.sueldo = ''
					this.cliente.prestamo.fecha_prox_pago = ''
					this.cliente.prestamo.direccion_trabajo = ''
					this.cliente.prestamo.fecha_ini_trabajo = ''
					this.cliente.prestamo.tiempo_trabajado = ''
					this.cliente.prestamo.horario = ''
					this.cliente.prestamo.nombre_supervisor = ''
					this.cliente.prestamo.nombre_rrhh = ''
					this.cliente.prestamo.persona_expuesta = ''
					this.cliente.prestamo.nivel = ''
					this.cliente.prestamo.permite_avisos = ''
					this.cliente.prestamo.ingresos_aproximados = ''
					this.cliente.prestamo.ingresos_reales = ''
					this.cliente.prestamo.egresos_aproximados = ''
					this.cliente.prestamo.egresos_reales = ''
					this.cliente.prestamo.capacidad_endeudamiento = ''
					this.cliente.prestamo.es_profesional = ''
					this.cliente.prestamo.esta_orgulloso_actividades = ''
					this.cliente.prestamo.edad = ''
					this.cliente.prestamo.tiene_dependiente_economico = ''
					this.cliente.prestamo.ocupacion = ''
					this.cliente.prestamo.inicio_labores = ''
					this.cliente.prestamo.capacidad_endeudamiento_porcentaje = ''
					this.cliente.prestamo.departamento = ''
					this.cliente.prestamo.municipio = ''
					this.cliente.prestamo.afiliacion_igss = ''
				}
			}
		},

		computed: {
			configuracion(){
				return this.configuracionBase
			},

			hasPrestamos(){
				return crm.tipoCrm.is_prestamos
			},

			errorPrestamo(){
				return this.errors.prestamo || {}
			},

			avatar_url(){
				if (this.cliente.avatar_url) {
					return crm.route.storage_public + '/' + this.cliente.avatar_url
				}

				return null
			},

			totalIngEgrReales(){
				return this.money((this.cliente.prestamo.ingresos_reales || 0) - (this.cliente.prestamo.egresos_reales || 0), true)
			}
		}
	}
</script>